import { memo } from "react";

import { CalendarProvider } from "./calendar/calendar-context";

import type { CalendarProps } from "../calendar";

type RootProviderProps = {
	initialProps: CalendarProps;
	children: React.ReactNode;
};

export const RootProvider = memo(({ initialProps, children }: RootProviderProps) => {
	return <CalendarProvider initialProps={initialProps}>{children}</CalendarProvider>;
});

RootProvider.displayName = "RootProvider";
